import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/mobile/payali-icon.png'
import _imports_1 from '@/assets/images/mobile/USDT3.png'


const _withScopeId = n => (_pushScopeId("data-v-6c9b9d9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog p-3 rounded-top-3" }
const _hoisted_2 = { class: "title text-black" }
const _hoisted_3 = { class: "content-1 rounded-3 p-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_5 = { class: "flex-grow-1 d-flex flex-wrap ms-2" }
const _hoisted_6 = { class: "me-2 text-black fs-17-custom" }
const _hoisted_7 = { class: "mb-0 fs-11-custom me-2 fee rounded-1" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-right p-0 ms-1" })
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_10 = { class: "flex-grow-1 d-flex flex-wrap flex-column ms-2" }
const _hoisted_11 = { class: "flex-grow-1 d-flex flex-wrap" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "me-2 text-black fs-17-custom" }, "USDT", -1))
const _hoisted_13 = { class: "mb-0 fs-11-custom me-2 fee rounded-1" }
const _hoisted_14 = { class: "fs-11-custom fee-note-usdt mb-0 text-start mt-1" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-right p-0 ms-1" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString($setup.local.withdraw_23), 1),
    _createElementVNode("button", {
      class: "hide-btn position-absolute border-0 bg-transparent fs-15-custom",
      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.hide_()))
    }, _toDisplayString($setup.local.withdraw_24), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "d-flex align-items-start border-w pb-2",
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.change_($setup.data.method[0]))),
        role: "button"
      }, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString($setup.local.withdraw_11), 1),
          _createElementVNode("p", _hoisted_7, _toDisplayString($setup.local.withdraw_12), 1)
        ]),
        _hoisted_8
      ]),
      _createElementVNode("div", {
        class: "d-flex align-items-start pt-2",
        role: "button",
        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.change_($setup.data.method[1])))
      }, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("p", _hoisted_13, _toDisplayString($setup.local.withdraw_30), 1)
          ]),
          _createElementVNode("p", _hoisted_14, _toDisplayString($setup.local.withdraw_20) + " +0.2", 1)
        ]),
        _hoisted_15
      ])
    ])
  ]))
}